module.exports = __webpack_public_path__ + "static/media/presentation.da610d06.pptx";